var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13917_9179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41306 18.8859L17.4132 10.8857L13.6133 7.08578L5.61312 15.086C5.50298 15.1962 5.42475 15.3343 5.38671 15.4854L4.5 19.999L9.01275 19.1123C9.16426 19.0744 9.30286 18.9961 9.41306 18.8859ZM19.9959 8.30307C20.3187 7.98019 20.5 7.54233 20.5 7.08578C20.5 6.62923 20.3187 6.19137 19.9959 5.86849L18.6305 4.50313C18.3077 4.18035 17.8698 3.99902 17.4132 3.99902C16.9567 3.99902 16.5188 4.18035 16.196 4.50313L14.8306 5.86849L18.6305 9.66843L19.9959 8.30307Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13917_9179)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#C5C8CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisabled);
export default __webpack_public_path__ + "static/media/edit_disabled.4c89848d1a91c25d0fb01172353eb37b.svg";
export { ForwardRef as ReactComponent };